import { render, staticRenderFns } from "./PhysicalAddressInfo.vue?vue&type=template&id=623d8923&scoped=true"
import script from "./PhysicalAddressInfo.vue?vue&type=script&lang=js"
export * from "./PhysicalAddressInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d8923",
  null
  
)

export default component.exports